export const Environment = {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    appVersion: process.env.REACT_APP_VERSION,
    environment: process.env.REACT_APP_ENVIRONMENT,
    defaultVertical: process.env.REACT_APP_DEFAULT_VERTICAL,    
    enableAdjustmentManager: process.env.REACT_APP_ENABLE_ADJUSTMENT_MANAGER,
    azureAppClientId: process.env.REACT_APP_AZURE_APP_CLIENT_ID,
    azureAppAuthority: process.env.REACT_APP_AZURE_APP_AUTHORITY,
    azureAppRedirectUri: process.env.REACT_APP_AZURE_APP_REDIRECT_URI,
    azureAppPostLogoutRedirectUri: process.env.REACT_APP_AZURE_APP_POST_LOGOUT_REDIRECT_URI,
    azureAppScopes: process.env.REACT_APP_AZURE_APP_SCOPES,
    azureAppAPIScope: process.env.REACT_APP_AZURE_APP_API_SCOPE,
    azureEntraAppFulcrumAdminGroup: process.env.REACT_APP_AZURE_ENTRA_APP_FULCRUM_ADMIN_GROUP,
    azureEntraAppFulcrumUsersGroup: process.env.REACT_APP_AZURE_ENTRA_APP_FULCRUM_USERS_GROUP,
}
